import { gql } from "@apollo/client";

export const GET_MANY_USER_ADDRESS_FACEBOOK_ID = gql`
  query UserAddressFacebookId($where: UserAddressWhereInput) {
    userAddressFacebookId(where: $where) {
      total
      data {
        id
        user
        facebookId
        deliveryName
        userName
        userTel
        province
        district
        village
        branch
        labelAs
        codNumber
        default
        latLong
        location
        isOpen
        address
        receive_branch_id
        createdAt
        updatedAt
        img
        branchCode
      }
    }
  }
`;

// ຄົ້ນທີ່ຢູ່ຂົນສົ່ງດ້ວຍເບີໂທຢ່າງດຽວ (ໜ້າ order-confirm) — backend ບໍ່ຄືນ address/location ໃຫ້
export const GET_USER_ADDRESS_BY_PHONE = gql`
  query UserAddressByPhone($where: UserAddressPhoneInput!) {
    userAddressByPhone(where: $where) {
      total
      userId
      data {
        id
        user
        deliveryName
        userName
        userTel
        province
        district
        village
        branch
        branchCode
        labelAs
        codNumber
        default
        latLong
        isOpen
        receive_branch_id
        updatedAt
        img
      }
    }
  }
`;

export const GET_MANY_USER_ADDRESS_USER_ID = gql`
  query UserAddressUserId($where: UserAddressWhereInput) {
    userAddressUserId(where: $where) {
      total
      data {
        id
        user
        facebookId
        deliveryName
        userName
        userTel
        province
        district
        village
        branch
        labelAs
        codNumber
        default
        latLong
        location
        isOpen
        address
        receive_branch_id
        createdAt
        updatedAt
        img
        branchCode
      }
    }
  }
`;